<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";
    import { apiUrl } from "@/utils";

    export default {
        name: "VersionDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    status: "actual",
                    photoId: "",
                    brochureId: "",
                    modelId: this.$route.params.modelId || "",
                    name: "",
                    characteristics: {
                        acceleration: 0,
                        batteryCapacity: 0,
                        dimensions: "",
                        drivetrain: "",
                        drivingRange: 0,
                        enginePower: 0,
                        seatsCount: 0,
                        topSpeed: 0,
                        trunkVolume: 0,
                        weight: 0,
                    },
                },
                vendorId: "",
                specificationsList: [],
                file: null,
                preview: null,
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить комплектацию",
                    view: "Комплектация",
                    edit: "Редактировать комплектацию",
                };
                return filtered[this.statusPage];
            },
            formSpecification() {
                let arr = [];
                this.specificationsList.forEach((spec) => {
                    spec.items.forEach((item) => {
                        arr.push({
                            itemId: item.id,
                            value: item.value || "",
                        });
                    });
                });

                return arr;
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            } else {
                this.getSpecificationsWithVendorId();
            }
        },
        methods: {
            apiUrl,
            send() {
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "VersionEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.$store.autoAdminApi
                    .editVersion(this.$route.params.slug, {
                        ...this.form,
                        specification: this.formSpecification,
                    })
                    .then(() => {
                        this.$router.push({
                            name: "ModelView",
                            params: {
                                slug: this.form.modelId,
                            },
                        });
                    });
            },
            handlerForCreate() {
                // this.createSpecForForm();
                this.$store.autoAdminApi
                    .createVersion({
                        ...this.form,
                        specification: this.formSpecification,
                    })
                    .then(() => {
                        this.$router.push({
                            name: "ModelView",
                            params: {
                                slug: this.$route.params.modelId,
                            },
                        });
                    });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi
                    .getVersion(this.$route.params.slug)
                    .then(({ data: dataVersions }) => {
                        this.form.name = dataVersions.name;
                        this.form.characteristics = dataVersions.characteristics;
                        this.form.modelId = dataVersions.modelId;
                        this.form.brochureId = dataVersions.brochureId;
                        this.form.photoId = dataVersions.photoId;
                        this.form.status = dataVersions.status;

                        this.$store.autoAdminApi
                            .getModel(dataVersions.modelId)
                            .then(({ data: dataModel }) => {
                                this.vendorId = dataModel.vendorId;

                                this.$store.autoAdminApi
                                    .getSpecifications(this.vendorId)
                                    .then(({ data: dataSpecification }) => {
                                        this.specificationsList = dataSpecification.items;

                                        this.specificationsList.forEach((spec) => {
                                            spec.items.forEach((item) => {
                                                dataVersions.specification.forEach(
                                                    (dataSpec) => {
                                                        if (item.id === dataSpec.itemId) {
                                                            item.value = dataSpec.value;
                                                        }
                                                    }
                                                );
                                            });
                                        });
                                    });
                            });
                    });
            },
            getSpecificationsWithVendorId() {
                return this.$store.autoAdminApi
                    .getSpecifications(this.$route.params.vendorId)
                    .then(({ data }) => {
                        this.specificationsList = data.items;
                    });
            },
            uploadFile() {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("pdf", this.file);
                const fileReader = new FileReader();
                let arr = [];
                fileReader.onload = () => {
                    arr.push(fileReader.result);
                    this.$store.autoAdminApi
                        .uploadDocs({ file: arr })
                        .then(({ data }) => {
                            this.form.brochureId = data.id[0];
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                };
                fileReader.readAsDataURL(this.file);
            },
            uploadPhoto() {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("photo", this.preview);
                const fileReader = new FileReader();
                let arr = [];
                fileReader.onload = () => {
                    arr.push(fileReader.result);
                    this.$store.autoAdminApi
                        .uploadImages({ file: arr })
                        .then(({ data }) => {
                            this.form.photoId = data.id[0];
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                };
                fileReader.readAsDataURL(this.preview);
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <the-detail-wrapper
        :title="title"
        :type-list="`/model/${form.modelId}`"
        :current-status="statusPage"
        @handler-submit="send"
    >
        <b-field label="Id модели">
            <b-input v-model="form.modelId" disabled></b-input>
        </b-field>

        <b-field label="Название">
            <b-input v-model="form.name"></b-input>
        </b-field>

        <b-field label="Характеристики">
            <div class="columns">
                <div class="column">
                    <b-field
                        label="Разгон до 100
"
                        label-position="on-border"
                    >
                        <b-input v-model.number="form.characteristics.acceleration"></b-input>
                    </b-field>
                    <b-field label="Привод" label-position="on-border">
                        <b-input v-model="form.characteristics.drivetrain"></b-input>
                    </b-field>
                    <b-field
                        label="Количество посадочных мест
"
                        label-position="on-border"
                    >
                        <b-input v-model.number="form.characteristics.seatsCount"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field
                        label="Ёмкость батареи
"
                        label-position="on-border"
                    >
                        <b-input
                            v-model.number="form.characteristics.batteryCapacity"
                        ></b-input>
                    </b-field>
                    <b-field
                        label="Запас хода
"
                        label-position="on-border"
                    >
                        <b-input v-model.number="form.characteristics.drivingRange"></b-input>
                    </b-field>
                    <b-field label="Максимальная скорость" label-position="on-border">
                        <b-input v-model.number="form.characteristics.topSpeed"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Габариты" label-position="on-border">
                        <b-input v-model="form.characteristics.dimensions"></b-input>
                    </b-field>
                    <b-field label="Мощность двигателя" label-position="on-border">
                        <b-input v-model.number="form.characteristics.enginePower"></b-input>
                    </b-field>
                    <b-field label="Объем багажника" label-position="on-border">
                        <b-input v-model.number="form.characteristics.trunkVolume"></b-input>
                    </b-field>
                </div>
            </div>
        </b-field>

        <b-field label="Вес" label-position="on-border">
            <b-input v-model.number="form.characteristics.weight"></b-input>
        </b-field>

        <b-field label="Спецификации" custom-class="is-large"></b-field>

        <div
            class="vendor-detail-spec"
            v-for="specification in specificationsList"
            :key="specification.id"
        >
            <b-field :label="specification.name"></b-field>
            <b-field
                :label="field.name"
                v-for="field in specification.items"
                :key="field.id"
                custom-class="is-small"
            >
                <div class="columns">
                    <div class="column">
                        <b-field label="" label-position="on-border">
                            <b-input v-model="field.id" disabled=""></b-input>
                        </b-field>
                    </div>
                    <div class="column">
                        <b-field label="Значение" label-position="on-border">
                            <b-input v-model="field.value"></b-input>
                        </b-field>
                    </div>
                </div>
            </b-field>
        </div>

        <b-field label="Изображение" message="Размеры превью 411x246">
            <b-field class="file" :class="{ 'has-name': !!preview }">
                <b-upload v-model="preview" class="file-label" @input="uploadPhoto">
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Загрузить фото</span>
                    </span>
                    <span class="file-name" v-if="preview">
                        {{ preview.name }}
                    </span>
                </b-upload>
            </b-field>
        </b-field>
        <div class="block">
            <img
                class="preview-img-single"
                v-if="form.photoId"
                :src="apiUrl('/gallery/image/' + form.photoId + '.orig')"
                alt=""
            />
        </div>

        <b-field label="PDF">
            <b-field class="file" :class="{ 'has-name': !!file }">
                <b-upload v-model="file" class="file-label" @input="uploadFile">
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Загрузить pdf файл</span>
                    </span>
                    <span class="file-name" v-if="file">
                        {{ file.name }}
                    </span>
                </b-upload>
            </b-field>
        </b-field>
        <div v-if="form.brochureId" class="block">
            <a
                class="pdf-text"
                target="_blank"
                :href="apiUrl('/gallery/doc/' + form.brochureId)"
            >
                скачать PDF({{ form.brochureId }})
            </a>
        </div>
    </the-detail-wrapper>
</template>

<style lang="scss">
    .vendor-detail-spec {
        margin-bottom: 30px;
    }
</style>
